// @ts-nocheck
import { useState } from "react";

interface CheckBoxPickerOverrides {
    selectedItemsOverride: string[];
    setSelectedItemsOverride: (items: string[]) => void;
}
const useCheckboxPicker = (overrides?: CheckBoxPickerOverrides) => {
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const { selectedItemsOverride, setSelectedItemsOverride } = overrides || {};
    const selectedItemsToUse = selectedItemsOverride || selectedItems;
    const setSelectedItemsToUse = setSelectedItemsOverride || setSelectedItems;

    const toggleItem = (po: string) => {
        let newItems: string[] = [];
        const poIndex = selectedItemsToUse.findIndex(ponumber => ponumber === po);
        if (poIndex >= 0) {
            newItems = [...selectedItemsToUse.slice(0, poIndex), ...selectedItemsToUse.slice(poIndex + 1)];
            setSelectedItemsToUse(newItems);
        } else {
            newItems = [...selectedItemsToUse, po];
            setSelectedItemsToUse(newItems);
        }
        return newItems;
    };

    const toggleAllItems = (ids: string[]) => {
        let selectedItemsTemp = selectedItemsToUse;
        let iSelectedPOs = 0;
        let isAllSelected = false;

        [...ids].forEach(id => {
            const po = selectedItemsToUse.find(po => po === id);
            if (po) {
                iSelectedPOs++;
                selectedItemsTemp = selectedItemsTemp.filter(item => item !== po);
            }
        });
        isAllSelected = iSelectedPOs === ids.length;

        if (!isAllSelected) {
            selectedItemsTemp = [...selectedItemsTemp, ...ids];
        }

        setSelectedItemsToUse(selectedItemsTemp);
        return selectedItemsTemp;
    };

    return {
        selectedItems: selectedItemsToUse,
        toggleItem,
        toggleAllItems,
        setSelectedItems: setSelectedItemsToUse,
    };
};

export default useCheckboxPicker;
